import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import './lib/slick';
import lightbox from 'lightbox2';
//require('imagesloaded');
//var jQueryBridget = require('jquery-bridget');
//var Isotope = require('isotope-layout');
//jQueryBridget( 'isotope', Isotope, $ );
import { gsap, ScrollTrigger, Draggable, MotionPathPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, Draggable, MotionPathPlugin);

import ScrollMagic from 'scrollmagic';


$(document).foundation();

$(function() {
    $('a[href*=\\#]:not([href=\\#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            && location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 180//offsets for fixed header
                }, 800);
                return false;
            }
        }
    });
    if($(location.href.split("#")[1])) {
        var target = $('#'+location.href.split("#")[1]);
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - 180 //offset height of header here too.
            }, 800);
            return false;
        }
    }
});



var imageslider = $('.imageslider');
if (imageslider.length){
    $('.imageslider').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    centerMode:true,
                }
            },
        ]
    });
}


var zitate = $('.zitat');
if (zitate.length){
    $('.kundenstimmen').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}


lightbox.option({
    'albumLabel': "Bild %1 von %2",
})

var kunden = $('.kunden');
if (kunden.length) {
    gsap.timeline({
        scrollTrigger: {
            trigger: '.kunden',
            start: 'center center', // Center of scene and target element
            //end: '+=1000', // Top of scene and bottom if element
            scrub: 5, // Scroll based animation
        },
    })
        .to('.number', {y: -100});

    gsap.timeline({
        scrollTrigger: {
            trigger: '.kunden',
            start: 'center center', // Center of scene and target element
            //end: '+=1000', // Top of scene and bottom if element
            scrub: 5, // Scroll based animation
        },
    })
        .to('.img--scale img', {scale: 1.4});
}

var referenzen = $('.referenzen');
if (referenzen.length) {
    gsap.timeline({
        scrollTrigger: {
            trigger: '.referenzen',
            start: 'center center', // Center of scene and target element
            //end: '+=1000', // Top of scene and bottom if element
            scrub: 3, // Scroll based animation
        },
    })
        .to('.number', {y: -100});

    gsap.timeline({
        scrollTrigger: {
            trigger: '.referenzen',
            start: 'center center', // Center of scene and target element
            //end: '+=1000', // Top of scene and bottom if element
            scrub: 3, // Scroll based animation
        },
    })
        .to('.img--scale img', {scale: 1.4});
}

var presse = $('.presse');
if (presse.length) {
    $('.kunden--row').each(function() {
        gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'center center', // Center of scene and target element
                //end: '+=1000', // Top of scene and bottom if element
                scrub: 5, // Scroll based animation
            },
        })
            .to(this.querySelectorAll('.number'), {y: -100});
        gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'center center', // Center of scene and target element
                //end: '+=1000', // Top of scene and bottom if element
                scrub: 5, // Scroll based animation
            },
        })
            .to(this.querySelectorAll('.img--scale img'), {scale: 1.4});

    });
}




$('.leistungen--row').each(function() {
    gsap.timeline({
        scrollTrigger: {
            trigger: this,
            start: 'center center', // Center of scene and target element
            //end: '+=1000', // Top of scene and bottom if element
            scrub: 2, // Scroll based animation
        },
    })
        .to(this.querySelectorAll('.second'), { y: -100, offset: 50,})
});


$('.menusection').each(function() {
    var thisid = '.menu' + this.id;
    gsap.timeline({
        scrollTrigger: {
            trigger: this,
            start: '-20px', // Center of scene and target element
            end: '95%', // Top of scene and bottom if element
            scrub: 1, // Scroll based animation
            toggleClass: {targets: thisid, className: "fix"},
        },
    })
    console.log('hit');
        //.toggleClass(this, "fix") // add class to reveal
        //.to(this, { position: 'fixed'})
        //.to(this, { position: 'absolute'})

});

$(document).ready(function() {
    $("#backtotop").click(function(event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });

});
